module.exports = __webpack_public_path__ + "static/img/icon-NEW.b9fde38.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon-NEW.svg
// module id = Mf9H
// module chunks = 0